import React from 'react';
import { PageLayout } from 'containers/layout';
import SignFlowForm from 'containers/auth/SignFlowForm';

function SignFlowPage() {
  return (
    <PageLayout hideHeader>
      <div className="d-flex-center login-bg">
        <SignFlowForm />
      </div>
    </PageLayout>
  );
}

export default SignFlowPage;
